import React from "react";
import { FileQuestion } from "lucide-react";

interface NotFoundProps {
  message?: string;
}

export const NotFound: React.FC<NotFoundProps> = ({
  message = "Page not found.",
}) => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="flex flex-col items-center gap-4 text-center px-6">
      <FileQuestion className="h-12 w-12 text-muted-foreground/40" />
      <div>
        <h1 className="text-lg font-semibold text-foreground">Not Found</h1>
        <p className="text-sm text-muted-foreground mt-1">{message}</p>
      </div>
    </div>
  </div>
);
